import template from './report_leave_company.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeaveAvailCompanyViewModel
{
	constructor (page) 
	{
		this.page = page;
		this.company_id = ko.observable();
		this.include_resigned = ko.observable(false);
		this.last_refreshed = ko.observable();
		this.on_date_setting = ko.observable();
		this.employee_summary = ko.observableArray();
		this.companies = ko.observableArray();
		this.reportFieldNames = ko.observableArray();
		this.table_report = ko.observableArray([]);
		this.show_hint = ko.observable(true);
		this.show_no_data_message = ko.observable(false);
		this.leave_types = ko.observableArray([]);

		// Pagination
		this.current_page_number = ko.observable(1);
		this.page_count = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);
		this.pagination_summary = ko.observable('');
		
		// Sorting
		this.sort_field = ko.observable('surname');
		this.sort_order = ko.observable('ASC');
		
		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.load_table();
		});

		this.include_resigned.subscribe((newVal) => {
			//this.page.updateData();
		});

		this.company_id.subscribe((newVal) => {
			this.show_hint(true);
			this.show_no_data_message(false);
			this.table_report([]);
			this.company_id(newVal);
		});
	}

	update_click()
	{
		this.show_hint(false);
		this.page.load_table();
	}

	sort_column(column)
	{
		if (column && column.trim() !== '')
		{
			if (this.sort_field() === column) 
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			else
			{
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.load_table();
		}
	}

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.load_table();
	}

	show_report_help()
	{
		Grape.dialog.open('LeaveAvailableByCompanyHelp', { 'employee_id': this.page.bindings.id }, {});
	}

	download_clicked(v, e)
    {
        let url = '/download/company_leave_available/' + this.company_id() + '/' + this.include_resigned();
        
        // Add the date parameter if it exists
        if (this.on_date_setting() && this.on_date_setting().trim() !== '') {
            url += '/' + encodeURIComponent(this.on_date_setting());
        } else {
            url += '/undefined'; // or handle the missing date appropriately
        }
        
        window.location.href = url;
    }

    async refresh_mv_get_company_leave_view ()
    {
         let options = {
            table: 'process',
            schema: 'bgworker',
            filter: [{ value: 'refresh_mv_get_company_leave_available', op: '=', field: 'process_name' }]
        };

        let res = await Grape.fetches.getJSON('/api/record', options);

        let result = await Grape.dialog.open(
            'CreateSchedule',
            {
                process_name: 'refresh_mv_get_company_leave_available',
                process_id: res.records[0].process_id,
                params: {}
            });

        if (result.status === 'OK')
            this.page.updateData();
    }
}

class ReportLeaveAvailCompanyPage
{
    constructor (bindings)
    {
        this.bindings = bindings;
        this.viewModel = new ReportLeaveAvailCompanyViewModel(this);
    }

    async init()
    {
		// check access to page
        if (await Utils.redirectOnAccessDenied('CompanyLeaveAvailableReport')) return;

        document.title = tr('Leave Available By Company');
        window.current_page_title(tr('Leave Available By Company'));

        let res = await Grape.fetches.postJSON('/admin/get_companies_of_manager', { employee_id: Utils.current_employee_id() });

        if (res) {
            this.viewModel.companies(res.companies);
            
            // After companies are loaded, restore the last selected company
            const lastSelectedCompany = localStorage.getItem('last_selected_company_leave_report');
            console.log('Trying to restore company_id:', lastSelectedCompany); // Debug log
            
            if (lastSelectedCompany && res.companies.some(company => company.company_id == lastSelectedCompany)) {
                this.viewModel.company_id(lastSelectedCompany);
                console.log('Restored company_id:', lastSelectedCompany); // Debug log
            }
            
            // Re-enable localStorage saving after initialization
            this.viewModel.isInitializing = false;
            
            // Now trigger updateData if we have a selected company
            if (this.viewModel.company_id()) {
                this.updateData();
            }
        }

		let result = await Grape.fetches.getJSON('/api/record', {
			table: 'v_last_refresh_company_leave_report',
			schema: 'savanna'
		});

		if (result && result.records && result.records.length > 0)
		{
			this.viewModel.last_refreshed(result.records[0].last_refresh)
			this.viewModel.on_date_setting(result.records[0].on_date_setting)
		}
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/grape-processes/refresh_mv_get_company_leave_available/active_schedules', 
			{ process_name: 'refresh_mv_get_company_leave_available' }
		);

		if (res)
		{
			if (res.status == 'OK')
			{
				if (res.running == null)
				{
					this.load_table();// should skip since load button refresh table
					this.viewModel.show_hint(true); //show hint as default
				} 
				else
				{
					Grape.alerts.alert({
						type: 'warning',
						message: tr('This report is currently being generated and was started on ') +
							Utils.get_full_date(new Date(res.running[0].time_started)) +
							' ' + tr('at') + ' ' + Utils.get_time(new Date(res.running[0].time_started)) +
							'. ' + tr('Please reload this page once it is done'),
						title: tr('Process still busy')
					});
				}
			}
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	}

	async load_table()
	{
		let filter = [
			{ value: this.viewModel.company_id(), op: '=', field: 'company_id' },
			{ value: !this.viewModel.include_resigned(), op: '=', field: 'is_active' }
		];

		let options = {
			table: 'mv_get_company_leave_available',
			schema: 'savanna',
			offset: (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size(),
			limit: this.viewModel.current_page_size(),
			sortfield: this.viewModel.sort_field(),
			sortorder: this.viewModel.sort_order(),
			filter: filter
		};

		let res = await Grape.fetches.getJSON('/api/record', options);

		if (res.total === 0) 
		{
			this.viewModel.show_hint(false);
			this.viewModel.show_no_data_message(true);
			this.viewModel.table_report([]);
			return;
		}

		if (res && res.records)
		{
			let leave_types_map = new Map();

			res.records.forEach(record => {
				if (record.leave_summary && record.leave_summary.leave) {
					record.leave_summary.leave.forEach(leave => {
						if (!leave_types_map.has(leave.css_class_name)) {
							leave_types_map.set(leave.css_class_name, {
								description: leave.leave_type,
								css_class_name: leave.css_class_name,
								leave_type_id: leave.leave_type_id
							});
						}
					});
				}
			});

			// Convert map to array and set it
			let all_leave_types = Array.from(leave_types_map.values());
			this.viewModel.leave_types(all_leave_types);

			// Map records with leave balances
			let records = res.records.map(record => {
				let new_record = {
					...record,
					fullnames: record.leave_summary.firstname + ' ' + record.leave_summary.surname,
					id_number: record.leave_summary.id_number,
					department: record.leave_summary.department,
					employee_code: record.leave_summary.employee_code,
					company: record.leave_summary.company
				};

				// Initialize all leave types with '-' first for empty values 
				all_leave_types.forEach(leave_type => {
					new_record[leave_type.css_class_name] = '-';
				});

				// Add leave balances for each leave type this employee has
				if (record.leave_summary && record.leave_summary.leave) {
					record.leave_summary.leave.forEach(leave => {
						new_record[leave.css_class_name] = parseFloat(leave.closing_balance.toFixed(3));
					});
				}

				return new_record;
			});

			this.viewModel.table_report(records);
			this.viewModel.page_count(Math.ceil(res.total / this.viewModel.current_page_size()));
			this.viewModel.pagination_summary(
				`Showing ${(this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size() + 1} to ${
					Math.min(this.viewModel.current_page_number() * this.viewModel.current_page_size(), res.total)
				} of ${res.total} entries`
			);
		}
	}

    async adjustDateForReport()
    {
        let response = await Grape.dialog.open('ReportCompanyLeaveAvailableAdjustDate', {});
        if (response)
            this.updateData();
    }
}

export default {
    route: '[/]report/report_leave_company',
    page_class: ReportLeaveAvailCompanyPage,
    template: template,
    template_filename: 'translation/report_leave_company'
};
